import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_COMMUNICATION_LOGS',
    icon: 'MessageCircleIcon',
    action: constants.action.permissionCommunicationLogsList,
    resource: constants.resource.templatelogs,
    children: [
      {
        title: 'DEBTIA_LOGS',
        route: 'communicationlogs',
        action: constants.action.permissionCommunicationLogsList,
        resource: constants.resource.templatelogs,
      },
    ],
  },
]
